[
    {
        "type": "displayRegenerateDocumentsButton",
        "role": ["administrator", "broker"],
        "products": ["sn-commercial", "sn-small-business-insurance", "securemyoffer"]
    }
]
